import { useTranslation } from "react-i18next";
import { AppHeader as SharedAppHeader, AppHeaderDivider, ThemeToggle } from "@scryerlabs/ui";
import { AppBreadcrumb } from "./AppBreadcrumb";
import { AppHeaderDropdown } from "./AppHeaderDropdown";
import { CartDropdown } from "./CartDropdown";

interface AppHeaderProps {
  onToggleSidebar: () => void;
}

/**
 * The sticky bar, the scroll shadow and the breadcrumb row now come from
 * @scryerlabs/ui. What stays here is only what is genuinely front-office: the cart and the
 * account menu.
 *
 * The theme control was a CDropdown with Light and Dark items - two clicks for a boolean.
 * ThemeToggle is one button and keeps the same icon convention.
 */
export function AppHeader({ onToggleSidebar }: AppHeaderProps) {
  const { t } = useTranslation();

  return (
    <SharedAppHeader
      onToggleSidebar={onToggleSidebar}
      breadcrumb={<AppBreadcrumb />}
      end={
        <>
          <CartDropdown />

          <AppHeaderDivider />

          <ThemeToggle label={t("common:header.theme")} />

          <AppHeaderDivider />

          <AppHeaderDropdown />
        </>
      }
    />
  );
}
